// extracted by mini-css-extract-plugin
export default {"root":"RestaurantSection_root__uqJZ+","item-link":"RestaurantSection_item-link__XUgvn","paying":"RestaurantSection_paying__EJZ7U"};